module.exports = __webpack_public_path__ + "fonts/BrandingSF-Medium.66a265f1.ttf";